import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';

import Icon from '~/components/Icon/Icon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';

import styles from './DeliveryInfo.module.scss';

type Props = {
  classNames?: string;
};

const DeliveryInfo = ({ classNames }: Props) => {
  const { openModal } = useModal();
  const openDeliveryModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    openModal(ModalType.DeliveryInfo, 'checkout');

    e.preventDefault();
  };

  return (
    <button
      data-tooltip="info"
      onClick={openDeliveryModal}
      className={classes([styles.deliveryInfo, classNames])}
    >
      <Icon type="info" size={16} />
    </button>
  );
};

export default observer(DeliveryInfo);
